module.exports = __webpack_public_path__ + "img/icon_4.40ca71a0.png";